import {MethodType, ParamsFetchType, GenerateUrlApiType, ResponseType} from 'src_common/browser/apiUtils';
import { GenerateUrlApiParamsType } from 'src_common/server/webDriver/sdkApiWebUtils';


const decode = (status: number, data: ResponseType): unknown => {
    if (status === 200 && data.type === 'json') {
        return data.json;
    }

    throw new Error(`unhandled response ${status} - ${data.type}`);
};


export const getIsonis = {
    browser: {
        params: (): ParamsFetchType<void> => {
            return {
                type: MethodType.GET,
                url: '/api-web/isonis',
            };
        },
        decode: decode
    },
    express: {
        method: MethodType.GET,
        urlBrowser: '/api-web/isonis',
    },
    generateUrlApi: async (params: GenerateUrlApiParamsType<void>): Promise<GenerateUrlApiType> => {

        if (params.userSessionId === null) {
            return {
                passToBackend: false,
                status: 403,
                responseBody: {
                    errorMessage: 'User id invalid',
                }
            };
        }

        return {
            url: `${params.API_URL}/isonis-reporter/report/star-doppler/isonis-report`,
            passToBackend: true,
            headers: {
                'X-Client-Req-Id': `${params.userSessionId}`
            },
            method: MethodType.GET,
        };
    }
};
